import { isNil } from 'lodash';

export default {
  isTestSite() {
    return !isNil(process.env.VUE_APP_IS_TEST_SITE) &&
          'true' === process.env.VUE_APP_IS_TEST_SITE;
  },
};
